import Vue from 'vue';
const $t = Vue.prototype.$t

export const minRoomAmount = 1 // 最小房间数
export const maxRoomAmount = 10 // 最大房间数
export const maxAdultAmount = 8 // 每间房最多的成人数
export const minAdultAmount = 1 // 每间房最少的成人数
export const maxChildAmount = 3 // 每间房最多的儿童数
export const minChildAmount = 0 // 每间房最少的儿童数
export const maxTotalAmount = 20 // 最大可选总人数

/** 年龄可选列表 */
export const ages = [
  {value: 0, text: $t('UnderOneYearOld')},
  {value: 1, text: $t('Age_x', 'function', [1])},
  {value: 2, text: $t('Age_x', 'function', [2])},
  {value: 3, text: $t('Age_x', 'function', [3])},
  {value: 4, text: $t('Age_x', 'function', [4])},
  {value: 5, text: $t('Age_x', 'function', [5])},
  {value: 6, text: $t('Age_x', 'function', [6])},
  {value: 7, text: $t('Age_x', 'function', [7])},
  {value: 8, text: $t('Age_x', 'function', [8])},
  {value: 9, text: $t('Age_x', 'function', [9])},
  {value: 10, text: $t('Age_x', 'function', [10])},
  {value: 11, text: $t('Age_x', 'function', [11])},
  {value: 12, text: $t('Age_x', 'function', [12])},
  {value: 13, text: $t('Age_x', 'function', [13])},
  {value: 14, text: $t('Age_x', 'function', [14])},
  {value: 15, text: $t('Age_x', 'function', [15])},
  {value: 16, text: $t('Age_x', 'function', [16])},
  {value: 17, text: $t('Age_x', 'function', [17])},
]

/** 根据人数修改正房间数 */
export const fixedRoomAmountWithPeople = (currentRoomAmount, adultAmount) => {
  const minRoomAmount = Math.ceil(adultAmount / 8) // 最小房间数
  const maxRoomAmount = adultAmount // 最大房间数
  if (currentRoomAmount > maxRoomAmount) {
    return maxRoomAmount
  } else if (currentRoomAmount < minRoomAmount) {
    return minRoomAmount
  }
  return currentRoomAmount
}

export const getAgesText = (val) => {
  let item = ages.find(v => v.value === val)
  return item ? item.text : ''
}

/** 获取成人儿童 房间数的拼接展示结果 */
export const getShowRoomAndPeople = (xOrder) => {
  let RoomAmount = xOrder.RoomAmount
  let AdultAmount = xOrder.AdultAmount
  let ChildAmount = xOrder.ChildAmount
  if (ChildAmount > 0) {
    return $t('RoomAdult_x_x_x', 'function', [RoomAmount, AdultAmount, ChildAmount])
  }
  return $t('RoomAdult_x_x', 'function', [RoomAmount, AdultAmount])
}


/** 根据儿童数量和原有年龄数组 更新 当前年龄数组 */
export const initAgesWithOther = (ChildAmount, ages) => {
  if (ages.length >= ChildAmount) {
    return ages.slice(0, ChildAmount)
  } else {
    let currentAges = [...ages]
    currentAges.length = ChildAmount; // 扩展数组长度
    return Array.from(currentAges, v => v || 10) // 对数组空值填充固定值 10
  }
}

export const getRoomDes = (RoomAmount, AdultAmount, ChildAmount) => {
  if (ChildAmount > 0) {
    return $t('RoomAdult_x_x_x', 'function', [RoomAmount, AdultAmount, ChildAmount])
  }
  return $t('RoomAdult_x_x', 'function', [RoomAmount, AdultAmount])
}
